import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "cs";
    const v = window.localStorage.getItem("gm.lang");
    return v === "sk" || v === "en" || v === "cs" ? v : "cs";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("gm.lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () => setLang((l) => (l === "cs" ? "sk" : l === "sk" ? "en" : "cs")),
      t: translations[lang] || translations.cs,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
